import {noop} from '@benchling/js-utils';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {Registry} from 'constants/RegistryConstants';
import {InitialParentStorable, ModalPane, StorableModalCreateProps} from 'constants/SampleConstants';
import {ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateGridPaneState} from 'samples/grids/getCreateGridParams';
import * as ModalContainer from 'ui-library/ModalContainer';

import CreateBoxPane from './CreateBoxPane';
import CreateStorableModal from './CreateStorableModal';
import * as StorableActions from './StorableActions';

export interface CreateBoxModalProps {
  onRequestClose?: () => void;
  initialRegistry: Registry | null;
  initialParentStorable: InitialParentStorable | null;
  actionOrigin: ActionOrigin;
}

class CreateBoxModal extends React.Component<CreateBoxModalProps> {
  static open = (props: CreateBoxModalProps): void => {
    ModalContainer.open(CreateBoxModal, <CreateBoxModal {...props} onRequestClose={CreateBoxModal.close} />);
  };

  static close = (): void => {
    ModalContainer.close(CreateBoxModal);
  };

  private handleCreateBox = (
    onFinish: (errorMessage?: string) => void,
    createPropsArray: Array<StorableModalCreateProps>,
    paneState: CreateGridPaneState
  ): void => {
    StorableActions.createBox(paneState, onFinish);
  };

  render(): JSX.Element {
    return (
      <CreateStorableModal
        initialParentStorable={this.props.initialParentStorable}
        initialRegistry={this.props.initialRegistry}
        isParentStorableRequired={BenchlingConfig.ENABLE_REQUIRED_PARENT_STORABLE}
        modalPane={ModalPane.CREATE_BOX}
        onCreate={this.handleCreateBox}
        onRequestClose={this.props.onRequestClose ?? noop}
        paneClass={CreateBoxPane}
        analyticsMetadata={{actionOrigin: this.props.actionOrigin}}
      />
    );
  }
}

export default CreateBoxModal;
